import dynamic from 'next/dynamic'

const registry = {
  author: dynamic(() => import('./Author/Author')),
  citationbox: dynamic(() => import('./CitationBox/CitationBox')),
  clickpic: dynamic(() => import('./ClickPic/ClickPic')),
  storyline_headline: () => {}, // Is handled by own its widget component - has to be pagebuilded as delegation
  storyline_subheadline: dynamic(() => import('./StorylineSubHeadline/StorylineSubHeadline')),
  storyline_subtitle: () => {}, // Is handled by own its widget component - has to be pagebuilded as delegation
  storyline_paragraph: dynamic(() => import('./StorylineParagraph/StorylineParagraph')),
  storyline_table: dynamic(() => import('./StorylineTable/StorylineTable')),
  storyline_lead_text: dynamic(() => import('./StorylineLeadText/StorylineLeadText')),
  storyline_list_bulleted: dynamic(() => import('./StorylineListBulleted/StorylineListBulleted')),
  storyline_list_numbered: dynamic(() => import('./StorylineListNumbered/StorylineListNumbered')),
  'storyline_opinary-ntv': dynamic(() => import('./StorylineOpinary/StorylineOpinary')),
  'storyline_embed-ntv': dynamic(() => import('./StorylineEmbed/StorylineEmbed')),
  'storyline_googlemap-ntv': dynamic(() => import('./StorylineGoogleMap/StorylineGoogleMap')),
  gallery: () => {}, // Is handled by own its widget component - has to be pagebuilded as delegation
  picture: () => {}, // Ist handled by its own widget component - has to be pagebuilded as delegation
  storyline: () => {},
  video: () => {}, // Is handled by own its widget component - has to be pagebuilded as delegation
}

export default registry
